const Heading = ({ title, body }) => {
  return (
    <>
      <h1 className="text-center">{title}</h1>
      <p className="text-center" style={{ paddingBottom: 20 }}>
        {body}
      </p>
    </>
  );
};

export default Heading;
